module.exports = __webpack_public_path__ + "static/media/Lycamobile.b9e7f49e.svg";